import { Component, OnInit, AfterContentInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';
import { Subscription } from 'rxjs';
import { SessionService } from './core/auth/session.service';
import { ApiService } from './core/http/api.service';
import { SetTitleService } from './shared/services/title.service';
import { Title } from '@angular/platform-browser';
import { DeviceDetectorService } from 'ngx-device-detector';
import { PaidSupplierService } from './components/paid-supplier-verification/paid-supplier.service';
import { ApiCore } from './config/api';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  menuMode = 'sidebar';

  layout = 'blue';

  theme = 'blue';

  ripple!: boolean;

  colorScheme = 'dark';
  subscription: Subscription;

  constructor(
    private primengConfig: PrimeNGConfig,
    private api: ApiService,
    private session: SessionService,
    public primeNGConfig: PrimeNGConfig,
    public translate: TranslateService,
    private readonly title: SetTitleService,
    private readonly casinoName: Title,
    private deviceService: DeviceDetectorService,
    private readonly router: Router,
    private readonly paidSupplierService: PaidSupplierService
  ) {
    translate.addLangs(['es-MX']);
    translate.setDefaultLang('es-MX');

    this.subscription = this.translate.stream('primeng').subscribe((data) => {
      this.primeNGConfig.setTranslation(data);
    });

    this.paidSupplierService.launchGame$.subscribe((game) => {
      this.validateGameSession(game);
    });
  }

  async ngOnInit(): Promise<void> {
    this.primengConfig.ripple = true;
    this.ripple = true;
    await this.getOne();
    this.casinoName.setTitle(
      this.title.titleProject
        ? this.title.titleProject
        : this.session.getItem('casinoName') ?? ''
    );
  }

  ngAfterViewInit(): void {
    if (this.deviceService.isMobile() && this.deviceService.os === 'iOS') {
      this.preventZoomInIOS();
    }
  }

  validateGameSession(game: any) {
    const gameId = game.id ?? game.gameId;

    if(!gameId) {
      console.error('game id error');
      return;
    }

    this.api.getGameSession(ApiCore.SESSION_GAMES).subscribe((res) => {
      if (res.data.length === 0) {
        this.router.navigate(['/app/home/open-game', gameId]);
      } else {
        console.log('tiene un juego abierto');
      }
    });
  }

  private preventZoomInIOS(): void {
    const el = document.querySelector('meta[name=viewport]');
    if (el) {
      let content = el.getAttribute('content') || '';
      if (!content) return;
      const re = /maximum\-scale=[0-9\.]+/g;
      content = re.test(content)
        ? content?.replace(re, 'maximum-scale=1.0')
        : content + ', maximum-scale=1.0';
      el.setAttribute('content', content);
    }
  }

  getOperatorConfig(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.getCoorporateCasinoConfig().subscribe((res) => {
        this.session.setItem('operatorLogo', res.data.logoCasinoUrl);
      });
    });
  }

  async getOne() {
    try {
      //this.imgUrl = (await this.testService.get('mewtwo')).sprites.back_shiny;
      this.api.getCoorporateCasinoConfig().subscribe((res) => {
        this.session.setItem('operatorLogo', res.data.logoCasinoUrl);
      });
    } catch (error) {
      alert('Error happened');
      console.error(error);
    }
  }
}
